"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Hook that helps to manage multiple states without declaring each one separetly
 *
 * @param {Object} initialState
 * @param {Function} transformValue - middleware that allows to transofrm value that goes on set
 */
function useObjectState(initialStateProp, {
  transformValue,
  onChange
} = {}) {
  const isFirstRenderRef = (0, _react.useRef)(true);
  const initialState = (0, _react.useMemo)(() => typeof initialStateProp === 'function' ? initialStateProp() : initialStateProp, []);
  const [state, setState] = (0, _react.useState)(initialState);
  (0, _react.useEffect)(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }
    if (onChange) onChange(state);
  }, [state]);
  const handleChange = (0, _react.useCallback)((field, value) => {
    setState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      [field]: value
    }));
  }, []);
  const setStateByKey = {};
  Object.keys(initialState).forEach(key => {
    setStateByKey[key] = newValue => handleChange(key, transformValue ? transformValue(newValue, key) : newValue);
  });
  return [state, setStateByKey, setState];
}
var _default = exports.default = useObjectState;